export interface Person_Skill_Interface {
  id:number,
  person_id:number,
  skill_id:number,
  skillTitle:String,
  percennt:number,
}

export function Empty_Person_Skill_Interface(){
  return{
    id:0,
    person_id:0,
    skill_id:0,
    skillTitle:'',
    percennt:0
  }
}
